import { Component, input, signal, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { GalaxyAlertModule } from '@vendasta/galaxy/alert';
import { MatIcon } from '@angular/material/icon';
import { MatCardModule } from '@angular/material/card';
import { TranslateModule } from '@ngx-translate/core';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'ai-dismissible-info-banner',
  imports: [CommonModule, GalaxyAlertModule, MatIcon, MatCardModule, MatButtonModule, TranslateModule],
  templateUrl: './dismissible-info-banner.component.html',
  styleUrl: './dismissible-info-banner.component.scss',
})
export class DismissibleInfoBannerComponent implements OnInit {
  readonly storageKey = input.required<string>();
  readonly icon = input<string>();
  readonly title = input.required<string>();

  // Track whether the info banner has been closed
  readonly isInfoClosed = signal(false);
  readonly isClosing = signal(false);
  readonly hasUserInteracted = signal(false);

  ngOnInit(): void {
    this.isInfoClosed.set(this.getInfoClosedFromStorage());
  }

  private getInfoClosedFromStorage(): boolean {
    if (typeof localStorage !== 'undefined') {
      return localStorage.getItem(this.storageKey()) === 'true';
    }
    return false;
  }

  closeInfo(): void {
    this.isClosing.set(true);
    setTimeout(() => {
      this.isInfoClosed.set(true);
      this.isClosing.set(false);
      this.hasUserInteracted.set(true);
      if (typeof localStorage !== 'undefined') {
        localStorage.setItem(this.storageKey(), 'true');
      }
    }, 300);
  }

  reopenInfo(): void {
    this.isInfoClosed.set(false);
    this.hasUserInteracted.set(true);
    if (typeof localStorage !== 'undefined') {
      localStorage.removeItem(this.storageKey());
    }
  }
}
